'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Video(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$colorIcon = _ref.colorIcon,
      colorIcon = _ref$colorIcon === undefined ? '#FFF' : _ref$colorIcon,
      _ref$colorCircle = _ref.colorCircle,
      colorCircle = _ref$colorCircle === undefined ? '#A056B5' : _ref$colorCircle;

  return _react2.default.createElement(
    'svg',
    {
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      version: '1.1',
      x: '0px',
      y: '0px',
      viewBox: '0 0 58 58',
      style: { enableBackground: 'new 0 0 58 58' },
      xmlSpace: 'preserve',
      width: size,
      height: size
    },
    _react2.default.createElement('circle', {
      style: { fill: colorCircle },
      cx: 29,
      cy: 29,
      r: 29,
      'data-original': '#EBBA16'
    }),
    _react2.default.createElement('polygon', {
      style: { fill: colorIcon },
      points: '44,29 22,44 22,29.273 22,14',
      'data-original': '#FFFFFF',
      className: 'active-path',
      'data-old_color': '#3E0C0C'
    }),
    _react2.default.createElement('path', {
      style: { fill: colorIcon },
      d: 'M22 45a.999.999 0 0 1-1-1V14a.999.999 0 0 1 1.564-.826l22 15a1.001 1.001 0 0 1-.001 1.652l-22 15A1.002 1.002 0 0 1 22 45zm1-29.107v26.215L42.225 29 23 15.893z',
      'data-original': '#FFFFFF',
      className: 'active-path',
      'data-old_color': '#3E0C0C'
    })
  );
}

Video.propTypes = {
  size: _propTypes2.default.number,
  colorIcon: _propTypes2.default.string,
  colorCircle: _propTypes2.default.string
};

exports.default = Video;